export default __webpack_public_path__ + "static/media/error.9cd497e7.jpg";